enum OpenTaskType {
    BACKLOG = 'backlog',
    ACTIVE = 'active',
    PAUSED = 'paused',
}

export default OpenTaskType;
